module.exports = __webpack_public_path__ + "1ac002542399efa77699017e5af03eb4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/glyphs/w.png
// module id = 226
// module chunks = 0